import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { withRouter, useHistory } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CardContext from "../../context/card/CardContext";
import Preloader from "./../layout/Preloader";
import UnregActionMenu from "../layout/UnregActionMenu";
import useForm from "../../hooks/useForm";
import CartContext from "../../context/cart/CartContext";
import usePageTitle from "../../hooks/usePageTitle";

const ConfirmCard = (props) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const configContext = useContext(ConfigContext);
  const cardContext = useContext(CardContext);
  const cartContext = useContext(CartContext);

  const { loadItems, error } = cartContext;
  const { getConfigValueByCode, getConfigValueByName } = configContext;
  const { setAlert, clearAlerts } = alertContext;
  const { token } = authContext;
  const { isLoading, loadCard } = cardContext;

  const history = useHistory();

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Reload Card",
  });

  const [card, setCard] = useState({
    cardnumber: "",
    confirmcardnumber: "",
  });
  const [labels, setLabels] = useState({
    cardnumber: "",
    confirmcardnumber: "",
  });
  const { cardnumber, confirmcardnumber } = card;
  const cardnumberRef = useRef(null);
  const confirmcardnumberRef = useRef(null);

  const cardnumberValRef = useRef();
  cardnumberValRef.current = cardnumber;
  const isConfirmCardMatching = (value) => {
    console.log("COnfirm card to match", value);
    let isMatching = false;
    if (cardnumberValRef.current)
      isMatching = cardnumberValRef.current === value;

    return !isMatching ? " is not matching" : "";
  };

  const onChange = (e) => {
    setCard({ ...card, [e.target.name]: e.target.value });
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (cardnumber !== confirmcardnumber) {
      clearAlerts();
      // clearErrors();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 476);
      setAlert(msg, "danger");
    } else {
      clearAlerts();
      try {
        const res = await loadCard({ cardnumber }, token);
        console.log("Response: ", res.data);
        if (res && res.msgCode) {
          const msg = getConfigValueByCode(
            "generalConfig",
            "RESPONSE_MSG",
            res.msgCode
          );
          setAlert(msg, res.status === "ERROR" ? "danger" : "info");
        } else {
          console.log("Redirecting to reacharge link: ");
          history.push("/unreg-recharge-value");
        }
      } catch (err) {
        console.log("Error::::", JSON.stringify(err));
        let errMsg = getConfigValueByCode("generalConfig", "RESPONSE_MSG", 475);
        setAlert(errMsg, "danger");
      }
    }
  };

  useEffect(() => {
    if (!error) {
      loadItems({}, token);
    }
    let cardnumber = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.cardNumber"
    );
    let confirmcardnumber = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.confirmCardNumber"
    );
    setLabels({ ...labels, cardnumber, confirmcardnumber });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
  } = useForm({
    inputList: {
      cardnumber: cardnumberRef,
      confirmcardnumber: confirmcardnumberRef,
    },
    customRules: {
      confirmcardnumber: isConfirmCardMatching,
    },
    screenName: "card_details_serial",
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card]);

  return (
    <Fragment>
      <Popup role="alert" aria-relevant="all" />
      {isLoading && <Preloader />}
      <UnregActionMenu />
      <div
        className="privateView"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <div className="privateView__pageTitle">
          <div> RELOAD CARD</div>
          {/* <div className="privateView__pageTitle__note">
            <span className="required" aria-label="Input required">
              *
            </span>
            denotes a required field
          </div> */}
        </div>

        <div className="privateView__formBody">
          <form>
            <div className="privateView__formGroup">
              <label htmlFor="cardnumber">
                {labels.cardnumber}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>
                :{" "}
              </label>
              <input
                type="text"
                name="cardnumber"
                className="form-control"
                onChange={onChange}
                placeholder={labels.cardnumber}
                value={cardnumber}
                onBlur={validateField}
                ref={cardnumberRef}
                aria-required="true"
              />
              <div></div>
            </div>
            <div className="privateView__formGroup">
              <label htmlFor="confirmcardnumber">
                {labels.confirmcardnumber}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>
                :{" "}
              </label>
              <input
                type="text"
                name="confirmcardnumber"
                className="form-control"
                onChange={onChange}
                placeholder={labels.confirmcardnumber}
                value={confirmcardnumber}
                onBlur={validateField}
                ref={confirmcardnumberRef}
                aria-required="true"
              />
              <div></div>
            </div>
            <div className="privateView__formGroup">
              <input
                type="submit"
                value="CONTINUE"
                className="btn btn-block btn-primary privateView__button"
                onClick={onSubmit}
                disabled={!isFormValid}
              />
              <div></div>
              <div></div>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(ConfirmCard);
